const MuiSvgIcon = {
  root: {
    fontSize: '2.4rem',
  },
};

export default MuiSvgIcon;
